/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState } from "react";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout/DashboardLayout";
import style from "./index.module.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import { useEffect } from "react";
import { Pagination } from "../../../components/Pagination";
import { ScaleLoader } from "react-spinners";

import {
  DropDown,
  DateDropDown,
  DurationDropDown,
  OtpDropDown,
  OTPStatus,
  DeliveryStatus,
  SmsDropDown,
  SmsStatus,
  CampaignDateFilteerDropDown,
} from "./Filters";

import dayjs from "dayjs";
import { useRef } from "react";
import { useNavigate } from "react-router";
import { useClickOutside } from "../../../hooks/useClickOutside";

export const Card = ({ logsMetrics }) => {
  const cards = [
    {
      description: "Total Number Of Campagin",
      num: `${logsMetrics ? logsMetrics.totalJobs : "0"}`,
    },
    {
      description: "Total Number of Recipients",
      num: `${logsMetrics ? logsMetrics.totalReceipents : "0"}`,
    },
    {
      description: "Total Cost Of Campagins",
      num: `NGN ${logsMetrics ? logsMetrics.totalCost : "0"}`,
    },
  ];
  return (
    <div>
      <ul className={style["cards--container"]}>
        {cards.map((item, index) => (
          <li className={style["cards--item"]} key={index}>
            <header>
              <div className={style["metrics"]}>
                <h2>{item.num}</h2>
                <span className={style["icon"]}>
                  {index === 0 ? (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{ fill: "#990006" }}
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16 0.999955C15.9999 0.829563 15.9563 0.662021 15.8733 0.513226C15.7902 0.364431 15.6706 0.239319 15.5256 0.14976C15.3806 0.0602015 15.2152 0.00916769 15.045 0.00150116C14.8748 -0.00616537 14.7054 0.0297896 14.553 0.105954L6.763 3.99995H3C2.20435 3.99995 1.44129 4.31603 0.87868 4.87863C0.316071 5.44124 0 6.20431 0 6.99995C0 7.7956 0.316071 8.55867 0.87868 9.12127C1.44129 9.68388 2.20435 9.99995 3 9.99995H3.28L5.051 15.316C5.11735 15.5152 5.24472 15.6884 5.41505 15.8112C5.58538 15.934 5.79004 16 6 16H7C7.26522 16 7.51957 15.8946 7.70711 15.7071C7.89464 15.5195 8 15.2652 8 15V10.618L14.553 13.894C14.7054 13.9701 14.8748 14.0061 15.045 13.9984C15.2152 13.9907 15.3806 13.9397 15.5256 13.8501C15.6706 13.7606 15.7902 13.6355 15.8733 13.4867C15.9563 13.3379 15.9999 13.1703 16 13V0.999955Z"
                        fill="#990006"
                        fill-opacity="0.8"
                      />
                    </svg>
                  ) : index === 1 ? (
                    <svg
                      width="24"
                      height="18"
                      viewBox="0 0 24 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{
                          fill: "#990006",
                          padding: "2rem",
                          background: "gree",
                        }}
                        d="M10.5 18C10.5 18 9 18 9 16.5C9 15 10.5 10.5 16.5 10.5C22.5 10.5 24 15 24 16.5C24 18 22.5 18 22.5 18H10.5ZM16.5 9C17.6935 9 18.8381 8.52589 19.682 7.68198C20.5259 6.83807 21 5.69347 21 4.5C21 3.30653 20.5259 2.16193 19.682 1.31802C18.8381 0.474106 17.6935 0 16.5 0C15.3065 0 14.1619 0.474106 13.318 1.31802C12.4741 2.16193 12 3.30653 12 4.5C12 5.69347 12.4741 6.83807 13.318 7.68198C14.1619 8.52589 15.3065 9 16.5 9Z"
                        fill="#750005"
                        fill-opacity="0.8"
                      />
                      <path
                        style={{ fill: "#990006" }}
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.824 17.9999C7.60163 17.5316 7.49073 17.0182 7.5 16.4999C7.5 14.4674 8.52 12.3749 10.404 10.9199C9.46364 10.6302 8.48392 10.4885 7.5 10.4999C1.5 10.4999 0 14.9999 0 16.4999C0 17.9999 1.5 17.9999 1.5 17.9999H7.824Z"
                        fill="#750005"
                        fill-opacity="0.8"
                      />
                      <path
                        style={{ fill: "#990006" }}
                        d="M6.75 9C7.74456 9 8.69839 8.60491 9.40165 7.90165C10.1049 7.19839 10.5 6.24456 10.5 5.25C10.5 4.25544 10.1049 3.30161 9.40165 2.59835C8.69839 1.89509 7.74456 1.5 6.75 1.5C5.75544 1.5 4.80161 1.89509 4.09835 2.59835C3.39509 3.30161 3 4.25544 3 5.25C3 6.24456 3.39509 7.19839 4.09835 7.90165C4.80161 8.60491 5.75544 9 6.75 9Z"
                        fill="#750005"
                        fill-opacity="0.8"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        style={{ fill: "#990006" }}
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.9999 19.5999C12.546 19.5999 14.9878 18.5885 16.7881 16.7881C18.5885 14.9878 19.5999 12.546 19.5999 9.9999C19.5999 7.45382 18.5885 5.01203 16.7881 3.21168C14.9878 1.41133 12.546 0.399902 9.9999 0.399902C7.45382 0.399902 5.01203 1.41133 3.21168 3.21168C1.41133 5.01203 0.399902 7.45382 0.399902 9.9999C0.399902 12.546 1.41133 14.9878 3.21168 16.7881C5.01203 18.5885 7.45382 19.5999 9.9999 19.5999ZM11.1999 3.9999C11.1999 3.68164 11.0735 3.37642 10.8484 3.15137C10.6234 2.92633 10.3182 2.7999 9.9999 2.7999C9.68164 2.7999 9.37642 2.92633 9.15137 3.15137C8.92633 3.37642 8.7999 3.68164 8.7999 3.9999V4.1103C8.08311 4.2379 7.39921 4.50803 6.7887 4.9047C5.9223 5.4807 5.1999 6.4107 5.1999 7.5999C5.1999 8.7879 5.9223 9.7179 6.7887 10.2951C7.3647 10.6791 8.0535 10.9491 8.7999 11.0895V13.4187C8.3307 13.2663 7.9839 13.0383 7.7883 12.8139C7.68678 12.6893 7.56128 12.5864 7.41924 12.5113C7.27719 12.4361 7.1215 12.3903 6.9614 12.3764C6.80129 12.3626 6.64004 12.381 6.48721 12.4307C6.33438 12.4804 6.19308 12.5602 6.07169 12.6655C5.9503 12.7708 5.85131 12.8995 5.78057 13.0438C5.70984 13.188 5.6688 13.3451 5.6599 13.5055C5.65101 13.666 5.67443 13.8266 5.72878 13.9778C5.78313 14.129 5.8673 14.2678 5.9763 14.3859C6.6507 15.1647 7.6719 15.6771 8.7999 15.8895V15.9999C8.7999 16.3182 8.92633 16.6234 9.15137 16.8484C9.37642 17.0735 9.68164 17.1999 9.9999 17.1999C10.3182 17.1999 10.6234 17.0735 10.8484 16.8484C11.0735 16.6234 11.1999 16.3182 11.1999 15.9999V15.8895C11.9167 15.7619 12.6006 15.4918 13.2111 15.0951C14.0775 14.5191 14.7999 13.5891 14.7999 12.3999C14.7999 11.2119 14.0775 10.2819 13.2111 9.7047C12.6006 9.30803 11.9167 9.0379 11.1999 8.9103V6.5811C11.6691 6.7335 12.0159 6.9615 12.2115 7.1859C12.314 7.30748 12.4396 7.40748 12.581 7.48009C12.7225 7.55271 12.8769 7.59649 13.0354 7.6089C13.1939 7.6213 13.3533 7.60209 13.5044 7.55236C13.6554 7.50264 13.795 7.4234 13.9151 7.31924C14.0353 7.21509 14.1335 7.0881 14.2042 6.94566C14.2748 6.80322 14.3164 6.64815 14.3266 6.48949C14.3368 6.33082 14.3154 6.17171 14.2635 6.02139C14.2117 5.87108 14.1305 5.73257 14.0247 5.6139C13.3491 4.8351 12.3291 4.3227 11.1999 4.1103V3.9999Z"
                        fill="#990006"
                        fill-opacity="0.8"
                      />
                    </svg>
                  )}
                </span>
              </div>
              <p>{item.description}</p>
            </header>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Logs = () => {
  const [activeTab, setActiveTab] = useState("campaign");
  const userInfo = useSelector((state) => state.auth.authState);
  const [notFound, setNotFound] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [telemarketingJobs, setTelemarketingJobs] = useState(null);
  const [smsAndVoiceJobs, setSmsAndVoiceJobs] = useState([]);
  const [otpJobs, setOtpJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [otpCurrentPage, setOtpCurrentPage] = useState(1);
  const [voiceCurrentPage, setVoiceCurrentPage] = useState(1);
  const [filter, setFilter] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDate, setIsOpenDate] = useState(false);
  const [isOpenDuration, setIsOpenDuration] = useState(false);
  const [isOpenOtpDate, setIsOpenOtpDate] = useState(false);
  const [isOpenSmsDate, setIsOpenSmsDate] = useState(false);
  const [by, setBy] = useState({
    by: "All",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          style={{ fill: "black" }}
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12Z"
          fill="black"
        />
        <path
          style={{ fill: "black" }}
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12Z"
          fill="black"
        />
        <path
          style={{ fill: "black" }}
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0378 6.10356C9.4079 7.57435 9 9.65851 9 11.9999C9 14.3413 9.4079 16.4255 10.0378 17.8962C10.3533 18.633 10.7097 19.1812 11.0673 19.5344C11.4217 19.8844 11.736 20.0062 12 20.0062C12.264 20.0062 12.5783 19.8844 12.9327 19.5344C13.2903 19.1812 13.6467 18.633 13.9622 17.8962C14.5921 16.4255 15 14.3413 15 11.9999C15 9.65851 14.5921 7.57435 13.9622 6.10356C13.6467 5.36682 13.2903 4.81856 12.9327 4.46538C12.5783 4.11538 12.264 3.99365 12 3.99365C11.736 3.99365 11.4217 4.11538 11.0673 4.46538C10.7097 4.81856 10.3533 5.36682 10.0378 6.10356ZM10.0133 3.39814C10.5562 2.86196 11.2284 2.49365 12 2.49365C12.7716 2.49365 13.4438 2.86196 13.9867 3.39814C14.5264 3.93115 14.978 4.66521 15.3411 5.51304C16.0684 7.21139 16.5 9.50535 16.5 11.9999C16.5 14.4945 16.0684 16.7884 15.3411 18.4868C14.978 19.3346 14.5264 20.0687 13.9867 20.6017C13.4438 21.1378 12.7716 21.5062 12 21.5062C11.2284 21.5062 10.5562 21.1378 10.0133 20.6017C9.47362 20.0687 9.02201 19.3346 8.65891 18.4868C7.93157 16.7884 7.5 14.4945 7.5 11.9999C7.5 9.50535 7.93157 7.21139 8.65891 5.51304C9.02201 4.66521 9.47362 3.93115 10.0133 3.39814Z"
          fill="black"
        />
      </svg>
    ),
  });
  const [minduration, setMinDuration] = useState(0);
  const [maxduration, setMaxDuration] = useState(0);

  const [filteredData, setFilteredData] = useState(jobs?.data || otpJobs?.data);
  const [filteredSmsAndVoiceData, setFilteredSmsAndVoiceData] = useState(
    smsAndVoiceJobs?.data
  );
  const navigate = useNavigate();

  const tabs = [
    { label: "Campaign", key: "campaign" },
    { label: "SMS", key: "sms" },
    { label: "OTP", key: "otp" },
    { label: "Voice Message", key: "voice" },
  ];
  const th = [
    "S/N",
    "Date",
    "Campagin Name",
    "Type",
    "Message",
    "No of Recipients",
    "Cost",
  ];

  const otpTh = [
    "S/N",
    "Date",
    "Type",
    "Generated by",
    "Msisdn",
    "Duration",
    "Cost",
    "Delivery Status",
    "Status",
    // "Delivery Status",
  ];

  const smsTh = ["S/N", "Date", "Text", "Msisdn", "Cost", "Status"];

  const voiceTh = [
    "S/N",
    "Date",
    "Message",
    "Msisdn",
    "Duration",
    "Cost",
    "Status",
  ];

  // Search function starts here
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = jobs?.data.filter((data) => {
      return Object.values(data).join("").toLowerCase().includes(value);
    });
    setFilteredData(result);
  };

  const handleOtpSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = otpJobs?.data.filter((data) => {
      return Object.values(data).join("").toLowerCase().includes(value);
    });
    setFilteredData(result);
  };

  const handleSmsAndVoiceSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = smsAndVoiceJobs?.data.filter((data) => {
      return Object.values(data).join("").toLowerCase().includes(value);
    });
    setFilteredSmsAndVoiceData(result);
  };

  // Search ends here

  const handleTabChange = (tab) => {
    setActiveTab(tab.key);
    if (tab.key === "sms" || tab.key === "voice") {
      getSMSAndVoiceJobs(tab.key, voiceMessageFilter);
      setIsOpen(false);
    } else if (tab.key === "otp") {
      getOTPJobs(otpData);
      setIsOpen(false);
    } else if (tab.key === "campaign") {
      getAllJobs(campaignFilter);
      getJobsSummary();
      setIsOpen(false);
    }
  };

  // Campaign actions
  const campaignFilter = new FormData();

  campaignFilter.append("client_id", userInfo?.id);
  campaignFilter.append("token", userInfo.token);
  campaignFilter.append("page", currentPage);

  function nextPage(pageNumber) {
    setCurrentPage(pageNumber);

    if (filter) {
      campaignFilter.append("page", pageNumber);
      getAllJobs(campaignFilter);
    } else {
      campaignFilter.append("page", pageNumber);
      getAllJobs(campaignFilter, pageNumber);
    }
  }

  const getAllJobs = async (formData) => {
    setLoading(true);
    try {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs`,
          formData
        )
        .then((res) => {
          if (res.status === 200) {
            setJobs(res.data.data);
            setFilteredData(res.data.data.data);
          } else {
            setJobs(res.data.data);
            setFilteredData(res.data.data.data);
          }
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNotFound("No telemarketing job yet");
      console.log(error);
    }
  };

  const getJobsSummary = async () => {
    setLoading(true);
    try {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs/summary`,
          {
            client_id: userInfo.id,
            token: userInfo.token,
          }
        )
        .then((res) => {
          if (res.status === 200) {
            setTelemarketingJobs(res.data);
          } else {
            setTelemarketingJobs(res.data);
          }
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNotFound("No telemarketing job yet");
      console.log(error);
    }
  };

  useEffect(() => {
    if (isOpen && activeTab === "campaign" && startDate && endDate) {
      campaignFilter.append("date_from", dayjs(startDate).format("YYYY-MM-DD"));
      campaignFilter.append("date_to", dayjs(endDate).format("YYYY-MM-DD"));

      getAllJobs(campaignFilter);
    }
  }, [endDate, startDate, isOpen]);

  useEffect(() => {
    const getAllJobs = async () => {
      setLoading(true);
      try {
        axios
          .post(`${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs`, {
            client_id: userInfo.id,
            token: userInfo.token,
          })
          .then((res) => {
            if (res.status === 201) {
              setJobs(res.data.data);
              setFilteredData(res.data.data.data);
            } else {
              setJobs(res.data.data.data);
              setFilteredData(res.data.data);
            }
          });
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setNotFound("No telemarketing job yet");
        console.log(error);
      }
    };
    getAllJobs();
  }, []);

  useEffect(() => {
    const getJobsSummary = async () => {
      setLoading(true);
      try {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs/summary`,
            {
              client_id: userInfo.id,
              token: userInfo.token,
            }
          )
          .then((res) => {
            if (res.status === 200) {
              setTelemarketingJobs(res.data);
            } else {
              setTelemarketingJobs(res.data);
            }
          });
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setNotFound("No telemarketing job yet");
        console.log(error);
      }
    };
    getJobsSummary();
  }, []);

  const handleViewLog = (id, name) => {
    navigate(`/user/analytics/${id}/${name}`);
  };

  // Sms filter

  const smsFilter = new FormData();
  smsFilter.append("client_id", userInfo?.id);
  smsFilter.append("token", userInfo.token);
  smsFilter.append("page", voiceCurrentPage);

  const handleSmsFilter = (data) => {
    setBy(data);
    if (data.by === "All") {
      getSMSAndVoiceJobs(activeTab, smsFilter);
      setIsOpenSmsDate(false);
      setOpenStatus(false);
    } else if (data.by === "Date") {
      setIsOpenSmsDate(!isOpenSmsDate);
      setOpenStatus(false);
    } else if (data.by === "Status") {
      setOpenStatus(!openStatus);
      setIsOpenSmsDate(false);
    }
  };

  const handleSmsFilterByStatus = (status) => {
    smsFilter.append("status", status.toLowerCase());
    getSMSAndVoiceJobs(activeTab, smsFilter);
    setIsOpen(!isOpen);
    setOpenStatus(false);
  };

  useEffect(() => {
    if (isOpenSmsDate && activeTab === "sms" && startDate && endDate) {
      smsFilter.append("date_from", dayjs(startDate).format("YYYY-MM-DD"));
      smsFilter.append("date_to", dayjs(endDate).format("YYYY-MM-DD"));

      getSMSAndVoiceJobs(activeTab, smsFilter);
    }
  }, [endDate, startDate, isOpenSmsDate]);

  // Otp job actions and filter
  const getOTPJobs = async (formData) => {
    setLoading(true);
    try {
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/otp/dev/get`, formData)
        .then((res) => {
          if (res.status === 200) {
            setOtpJobs(res.data);
            setFilteredData(res.data.data);
          } else {
            setOtpJobs(res.data);
            setFilteredData(res.data.data);
          }
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNotFound("No sender IDs found yet. :(");
    }
  };

  const otpData = new FormData();
  otpData.append("client_id", userInfo?.id);
  otpData.append("token", userInfo.token);
  otpData.append("page", otpCurrentPage);
  // otpData.append("status", by.by);
  const [openDeliveryStatus, setOpenDeliveryStatus] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const handleOtpFilter = (filterBy) => {
    setFilter(true);
    setBy(filterBy);

    if (filterBy.by === "All") {
      getOTPJobs(otpData);
      setIsOpenOtpDate(false);
      setOpenDeliveryStatus(false);
      setOpenStatus(false);
      setIsOpen(!isOpen);
    } else if (filterBy.by === "Date") {
      setIsOpenOtpDate(!isOpenOtpDate);
      setOpenDeliveryStatus(false);
      setOpenStatus(false);
    } else if (filterBy.by === "Status") {
      setOpenStatus(!openStatus);
      setOpenDeliveryStatus(false);
      setIsOpenOtpDate(false);
    } else if (filterBy.by === "Delivery Status") {
      setOpenDeliveryStatus(!openDeliveryStatus);
      setOpenStatus(false);
      setIsOpenOtpDate(false);
    }
  };

  const handleOtpFilterByStatus = (status) => {
    otpData.append("status", status.toLowerCase());
    getOTPJobs(otpData);
    setIsOpen(!isOpen);
    setOpenStatus(false);
  };

  const handleOtpFilterByDeliveryStatus = (status) => {
    otpData.append("deliveryStatus", status.toLowerCase());
    getOTPJobs(otpData);
    setIsOpen(!isOpen);
    setOpenDeliveryStatus(false);
  };

  const otpNextPage = (pageNumber) => {
    setOtpCurrentPage(pageNumber);
    if (filter) {
      otpData.append("page", pageNumber);

      getOTPJobs(otpData);
    }

    otpData.append("page", pageNumber);
    getOTPJobs(otpData, pageNumber);
  };

  useEffect(() => {
    if (isOpenOtpDate && startDate && endDate) {
      otpData.append("date_from", dayjs(startDate).format("YYYY-MM-DD"));
      otpData.append("date_to", dayjs(endDate).format("YYYY-MM-DD"));
      getOTPJobs(otpData);
    }
  }, [endDate, startDate, isOpenOtpDate]);
  // voice message actions and filter

  const getSMSAndVoiceJobs = async (query, formData) => {
    setLoading(true);
    try {
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/telemarketing/dev/jobs/${query}`,
          formData
        )
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data.data);
            setSmsAndVoiceJobs(res.data);
            setFilteredSmsAndVoiceData(res.data.data);
          } else {
            setSmsAndVoiceJobs(res.data);
            setFilteredSmsAndVoiceData(res.data.data);
          }
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNotFound("No telemarketing job yet");
      console.log(error);
    }
  };

  const handleOpenDropdown = () => {
    setIsOpen(!isOpen);
    setIsOpenDate(false);
    setIsOpenDuration(false);
    setIsOpenSmsDate(false);
    setOpenStatus(false);
    setIsOpenOtpDate(false);
    setOpenDeliveryStatus(false);
  };

  const voiceMessageFilter = new FormData();

  voiceMessageFilter.append("client_id", userInfo?.id);
  voiceMessageFilter.append("token", userInfo.token);
  voiceMessageFilter.append("page", voiceCurrentPage);

  const handleVoiceMessageFilter = (filterBy) => {
    setBy(filterBy);
    setFilter(true);
    if (filterBy?.by === "Failed" || filterBy?.by === "Success") {
      voiceMessageFilter.append("status", filterBy?.by.toLowerCase());
      getSMSAndVoiceJobs(activeTab, voiceMessageFilter, voiceCurrentPage);
      setIsOpenDate(false);
      setIsOpenDuration(false);
      setIsOpen(!isOpen);
    } else if (filterBy?.by === "All") {
      getSMSAndVoiceJobs(activeTab, voiceMessageFilter);
      setIsOpenDate(false);
      setIsOpenDuration(false);
      setIsOpen(!isOpen);
    } else if (filterBy?.by === "Date") {
      setIsOpenDate(!isOpenDate);
      setIsOpenDuration(false);
    } else if (filterBy?.by === "Duration Listened") {
      setIsOpenDuration(!isOpenDuration);
      setIsOpenDate(false);
    }
  };

  function voiceMessageNextPage(pageNumber) {
    setVoiceCurrentPage(pageNumber);

    if (filter) {
      voiceMessageFilter.append("page", pageNumber);
      getSMSAndVoiceJobs(activeTab, voiceMessageFilter);
    } else {
      voiceMessageFilter.append("page", pageNumber);
      getSMSAndVoiceJobs(activeTab, voiceMessageFilter, pageNumber);
    }
  }

  useEffect(() => {
    if (isOpenDate && activeTab === "voice" && startDate && endDate) {
      voiceMessageFilter.append(
        "date_from",
        dayjs(startDate).format("YYYY-MM-DD")
      );
      voiceMessageFilter.append("date_to", dayjs(endDate).format("YYYY-MM-DD"));

      getSMSAndVoiceJobs(activeTab, voiceMessageFilter);
    }
  }, [endDate, startDate, isOpenDate]);

  useEffect(() => {
    if (isOpenDuration && minduration && maxduration) {
      voiceMessageFilter.append("min_sec_duration", minduration);
      voiceMessageFilter.append("max_sec_duration", maxduration);
      getSMSAndVoiceJobs(activeTab, voiceMessageFilter);
    }
  }, [minduration, maxduration, isOpenDuration]);

  const closeRef = useRef();
  useClickOutside(closeRef, setIsOpen);

  return (
    <Layout pageTitle="Analytics">
      <div style={{ padding: "2rem" }}>
        <div className={style["tabs"]}>
          <div className={style["underline"]}></div>
          {activeTab === "campaign" && (
            <div className={style["campaign"]}></div>
          )}
          {activeTab === "sms" && <div className={style["sms"]}></div>}
          {activeTab === "otp" && <div className={style["otp"]}></div>}
          {activeTab === "voice" && <div className={style["voice"]}></div>}
          {tabs.map((tab, index) => (
            <div
              className={
                activeTab === tab.key ? style["active-tab"] : style["tab"]
              }
              key={index}
              onClick={() => handleTabChange(tab)}
            >
              {tab.label}
            </div>
          ))}
        </div>

        {activeTab === "campaign" && (
          <>
            <div ref={closeRef}>
              {isOpen && (
                <CampaignDateFilteerDropDown
                  startDate={startDate}
                  endDate={endDate}
                  handleStartDate={(date) => setStartDate(date)}
                  handleEndDate={(date) => setEndDate(date)}
                />
              )}
            </div>
            <Card
              logsMetrics={
                telemarketingJobs && {
                  totalJobs: telemarketingJobs.totalJobs
                    ? telemarketingJobs.totalJobs
                    : 0,
                  totalReceipents: telemarketingJobs.totalReceipents
                    ? telemarketingJobs.totalReceipents
                    : 0,
                  totalCost: telemarketingJobs.totalCost
                    ? telemarketingJobs.totalCost
                    : 0,
                }
              }
            />

            <div className={style["table--top"]}>
              <div className={style["search-input"]}>
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                />
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style={{ fill: "#fff" }}
                      d="M19 19L13 13M15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <Button
                type="button"
                className="filter--button"
                onClick={handleOpenDropdown}
              >
                <span>
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.128568 2.26839L2.31563 0.125478C2.48647 -0.0418526 2.7636 -0.0417991 2.93434 0.125478L5.12132 2.26839C5.39667 2.53812 5.20059 3.00001 4.81195 3.00001H3.5V11.5714C3.5 11.8081 3.30414 12 3.0625 12H2.1875C1.94586 12 1.75 11.8081 1.75 11.5714V3.00001H0.437935C0.0485329 3.00001 -0.146209 2.53758 0.128568 2.26839ZM6.5625 1.7143H13.5625C13.8041 1.7143 14 1.52243 14 1.28573V0.428584C14 0.191879 13.8041 1.34454e-05 13.5625 1.34454e-05H6.5625C6.32086 1.34454e-05 6.125 0.191879 6.125 0.428584V1.28573C6.125 1.52243 6.32086 1.7143 6.5625 1.7143ZM6.125 4.71429V3.85715C6.125 3.62045 6.32086 3.42858 6.5625 3.42858H11.8125C12.0541 3.42858 12.25 3.62045 12.25 3.85715V4.71429C12.25 4.951 12.0541 5.14287 11.8125 5.14287H6.5625C6.32086 5.14287 6.125 4.951 6.125 4.71429ZM6.125 11.5714V10.7143C6.125 10.4776 6.32086 10.2857 6.5625 10.2857H8.3125C8.55414 10.2857 8.75 10.4776 8.75 10.7143V11.5714C8.75 11.8081 8.55414 12 8.3125 12H6.5625C6.32086 12 6.125 11.8081 6.125 11.5714ZM6.125 8.14286V7.28572C6.125 7.04901 6.32086 6.85715 6.5625 6.85715H10.0625C10.3041 6.85715 10.5 7.04901 10.5 7.28572V8.14286C10.5 8.37957 10.3041 8.57143 10.0625 8.57143H6.5625C6.32086 8.57143 6.125 8.37957 6.125 8.14286Z"
                      fill="#BDBDBD"
                    />
                  </svg>
                </span>
                Filter By Date
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style={{ fill: "transparent" }}
                      d="M6 5V1M14 5V1M5 9H15M3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Button>
            </div>

            <div className={style["table--container"]}>
              <table
                id="test"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.4)",
                  borderRadius: "50px",
                }}
              >
                <thead>
                  <tr>
                    {th.map((item, index) => {
                      return <th key={index}>{item}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {notFound ? (
                    <tr className={style["empty--table"]}>
                      <span>
                        <svg
                          width="56"
                          height="46"
                          viewBox="0 0 56 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M45.5 45.5L56 17.5H10.5L0 45.5H45.5ZM7 14L0 45.5V0H15.75L22.75 7H45.5V14H7Z"
                            fill="#828282"
                          />
                        </svg>
                      </span>
                      <p>
                        Oops! you do not have any Job <br />
                        at the moment.
                      </p>
                    </tr>
                  ) : loading ? (
                    <ScaleLoader />
                  ) : (
                    filteredData?.map((job, index) => (
                      <tr
                        key={index}
                        className={style["table--body"]}
                        onClick={() => handleViewLog(job.id, job.name)}
                      >
                        <td>{index + 1}</td>
                        <td>{job.created_at}</td>
                        <td>{job.name}</td>
                        <td>{job.type}</td>
                        <td>
                          {job.message_text
                            ? job.message_text
                            : job.message_audio}
                        </td>
                        <td>{job.reciepentsno}</td>
                        <td>NGN {job.cost}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className={style["pagination--container"]}>
              {notFound || !jobs ? (
                ""
              ) : (
                <Pagination
                  numberOfPages={Math.ceil(jobs.total / 15)}
                  currentPage={currentPage}
                  nextPage={nextPage}
                />
              )}
            </div>
          </>
        )}

        {activeTab === "otp" && (
          <>
            <div ref={closeRef}>
              {isOpen && (
                <OtpDropDown handleSelect={(item) => handleOtpFilter(item)} />
              )}
              {isOpenOtpDate && (
                <DateDropDown
                  startDate={startDate}
                  endDate={endDate}
                  handleStartDate={(date) => setStartDate(date)}
                  handleEndDate={(date) => setEndDate(date)}
                />
              )}

              {openStatus && (
                <OTPStatus
                  handleClick={(status) => handleOtpFilterByStatus(status)}
                />
              )}

              {openDeliveryStatus && (
                <DeliveryStatus
                  handleClick={(status) =>
                    handleOtpFilterByDeliveryStatus(status)
                  }
                />
              )}
            </div>
            <div className={style["table--top"]}>
              <div className={style["search-input"]}>
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleOtpSearch}
                />
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style={{ fill: "#fff" }}
                      d="M19 19L13 13M15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <Button
                type="button"
                className="filter--button"
                onClick={handleOpenDropdown}
              >
                <span>
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.128568 2.26839L2.31563 0.125478C2.48647 -0.0418526 2.7636 -0.0417991 2.93434 0.125478L5.12132 2.26839C5.39667 2.53812 5.20059 3.00001 4.81195 3.00001H3.5V11.5714C3.5 11.8081 3.30414 12 3.0625 12H2.1875C1.94586 12 1.75 11.8081 1.75 11.5714V3.00001H0.437935C0.0485329 3.00001 -0.146209 2.53758 0.128568 2.26839ZM6.5625 1.7143H13.5625C13.8041 1.7143 14 1.52243 14 1.28573V0.428584C14 0.191879 13.8041 1.34454e-05 13.5625 1.34454e-05H6.5625C6.32086 1.34454e-05 6.125 0.191879 6.125 0.428584V1.28573C6.125 1.52243 6.32086 1.7143 6.5625 1.7143ZM6.125 4.71429V3.85715C6.125 3.62045 6.32086 3.42858 6.5625 3.42858H11.8125C12.0541 3.42858 12.25 3.62045 12.25 3.85715V4.71429C12.25 4.951 12.0541 5.14287 11.8125 5.14287H6.5625C6.32086 5.14287 6.125 4.951 6.125 4.71429ZM6.125 11.5714V10.7143C6.125 10.4776 6.32086 10.2857 6.5625 10.2857H8.3125C8.55414 10.2857 8.75 10.4776 8.75 10.7143V11.5714C8.75 11.8081 8.55414 12 8.3125 12H6.5625C6.32086 12 6.125 11.8081 6.125 11.5714ZM6.125 8.14286V7.28572C6.125 7.04901 6.32086 6.85715 6.5625 6.85715H10.0625C10.3041 6.85715 10.5 7.04901 10.5 7.28572V8.14286C10.5 8.37957 10.3041 8.57143 10.0625 8.57143H6.5625C6.32086 8.57143 6.125 8.37957 6.125 8.14286Z"
                      fill="#BDBDBD"
                    />
                  </svg>
                </span>
                Filter By {by?.by.split(" ")[0]}
                <span>{by?.icon}</span>
              </Button>
            </div>

            <div className={style["table--container"]}>
              <table
                id="test"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.4)",
                  borderRadius: "50px",
                }}
              >
                <thead>
                  <tr>
                    {otpTh.map((item, index) => {
                      return <th key={index}>{item}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {notFound ? (
                    <tr className={style["empty--table"]}>
                      <span>
                        <svg
                          width="56"
                          height="46"
                          viewBox="0 0 56 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M45.5 45.5L56 17.5H10.5L0 45.5H45.5ZM7 14L0 45.5V0H15.75L22.75 7H45.5V14H7Z"
                            fill="#828282"
                          />
                        </svg>
                      </span>
                      <p>
                        Oops! you do not have any Job <br />
                        at the moment.
                      </p>
                    </tr>
                  ) : loading ? (
                    <ScaleLoader />
                  ) : (
                    filteredData?.map((job, index) => (
                      <tr
                        key={index}
                        className={style["table--body"]}
                        onClick={() => handleViewLog(job.id, job.name)}
                      >
                        <td>{index + 1}</td>
                        <td>{job.created_at}</td>
                        <td>{job.type}</td>
                        <td>{job.generated_by}</td>
                        <td>{job.msisdn}</td>
                        <td>
                          {job.duration_in_seconds
                            ? job.duration_in_seconds
                            : 0}
                          s
                        </td>
                        <td>NGN {job.deliverycost}</td>
                        <td>
                          {job?.deliverystatus?.toLowerCase() === "success" ? (
                            <span className={style["success"]}>
                              {job?.deliverystatus}
                            </span>
                          ) : job?.deliverystatus?.toLowerCase() ===
                            "failed" ? (
                            <span className={style["failed"]}>
                              {job?.deliverystatus}
                            </span>
                          ) : (
                            <span className={style["new"]}>
                              {job?.deliverystatus}
                            </span>
                          )}
                        </td>
                        <td>
                          {job.status.toLowerCase() === "verified" ? (
                            <span className={style["success"]}>
                              {job.status}
                            </span>
                          ) : job.status.toLowerCase() === "processed" ? (
                            <span className={style["sent"]}>{job.status}</span>
                          ) : (
                            <span className={style["new"]}>{job.status}</span>
                          )}
                        </td>
                        {/* <td>
                          {job?.deliverystatus.toLowerCase() === "delivered" ? (
                            <span className={style["success"]}>
                              {job?.deliverystatus}
                            </span>
                          ) : job?.deliverystatus.toLowerCase() === "sent" ? (
                            <span className={style["sent"]}>
                              {job?.deliverystatus}
                            </span>
                          ) : (
                            <span className={style["new"]}>
                              {job?.deliverystatus}
                            </span>
                          )}
                        </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className={style["pagination--container"]}>
              {notFound || !otpJobs ? (
                ""
              ) : (
                <Pagination
                  numberOfPages={Math.ceil(otpJobs?.total / 15)}
                  currentPage={otpCurrentPage}
                  nextPage={otpNextPage}
                />
              )}
            </div>
          </>
        )}

        {activeTab === "sms" && (
          <>
            <div ref={closeRef}>
              {isOpen && (
                <SmsDropDown handleSelect={(data) => handleSmsFilter(data)} />
              )}
              {isOpenSmsDate && (
                <DateDropDown
                  startDate={startDate}
                  endDate={endDate}
                  handleStartDate={(date) => setStartDate(date)}
                  handleEndDate={(date) => setEndDate(date)}
                />
              )}

              {openStatus && (
                <SmsStatus
                  handleClick={(status) => handleSmsFilterByStatus(status)}
                />
              )}
            </div>
            <div className={style["table--top"]}>
              <div className={style["search-input"]}>
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleOtpSearch}
                />
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style={{ fill: "#fff" }}
                      d="M19 19L13 13M15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <Button
                type="button"
                className="filter--button"
                onClick={handleOpenDropdown}
              >
                <span>
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.128568 2.26839L2.31563 0.125478C2.48647 -0.0418526 2.7636 -0.0417991 2.93434 0.125478L5.12132 2.26839C5.39667 2.53812 5.20059 3.00001 4.81195 3.00001H3.5V11.5714C3.5 11.8081 3.30414 12 3.0625 12H2.1875C1.94586 12 1.75 11.8081 1.75 11.5714V3.00001H0.437935C0.0485329 3.00001 -0.146209 2.53758 0.128568 2.26839ZM6.5625 1.7143H13.5625C13.8041 1.7143 14 1.52243 14 1.28573V0.428584C14 0.191879 13.8041 1.34454e-05 13.5625 1.34454e-05H6.5625C6.32086 1.34454e-05 6.125 0.191879 6.125 0.428584V1.28573C6.125 1.52243 6.32086 1.7143 6.5625 1.7143ZM6.125 4.71429V3.85715C6.125 3.62045 6.32086 3.42858 6.5625 3.42858H11.8125C12.0541 3.42858 12.25 3.62045 12.25 3.85715V4.71429C12.25 4.951 12.0541 5.14287 11.8125 5.14287H6.5625C6.32086 5.14287 6.125 4.951 6.125 4.71429ZM6.125 11.5714V10.7143C6.125 10.4776 6.32086 10.2857 6.5625 10.2857H8.3125C8.55414 10.2857 8.75 10.4776 8.75 10.7143V11.5714C8.75 11.8081 8.55414 12 8.3125 12H6.5625C6.32086 12 6.125 11.8081 6.125 11.5714ZM6.125 8.14286V7.28572C6.125 7.04901 6.32086 6.85715 6.5625 6.85715H10.0625C10.3041 6.85715 10.5 7.04901 10.5 7.28572V8.14286C10.5 8.37957 10.3041 8.57143 10.0625 8.57143H6.5625C6.32086 8.57143 6.125 8.37957 6.125 8.14286Z"
                      fill="#BDBDBD"
                    />
                  </svg>
                </span>
                Filter By {by.by.split(" ")[0]}
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style={{ fill: "transparent" }}
                      d="M6 5V1M14 5V1M5 9H15M3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Button>
            </div>

            <div className={style["table--container"]}>
              <table
                id="test"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.4)",
                  borderRadius: "50px",
                }}
              >
                <thead>
                  <tr>
                    {smsTh.map((item, index) => {
                      return <th key={index}>{item}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {notFound ? (
                    <tr className={style["empty--table"]}>
                      <span>
                        <svg
                          width="56"
                          height="46"
                          viewBox="0 0 56 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M45.5 45.5L56 17.5H10.5L0 45.5H45.5ZM7 14L0 45.5V0H15.75L22.75 7H45.5V14H7Z"
                            fill="#828282"
                          />
                        </svg>
                      </span>
                      <p>
                        Oops! you do not have any Job <br />
                        at the moment.
                      </p>
                    </tr>
                  ) : loading ? (
                    <ScaleLoader />
                  ) : (
                    filteredSmsAndVoiceData?.map((job, index) => (
                      <tr
                        key={index}
                        className={style["table--body"]}
                        onClick={() => handleViewLog(job.id, job.name)}
                      >
                        <td>{index + 1}</td>
                        <td>{job.created_at}</td>
                        <td>{job.message_text}</td>
                        <td>{job.msisdn}</td>
                        <td>NGN {job.local_cost}</td>
                        <td>
                          {job.status.toLowerCase() === "success" ? (
                            <span className={style["success"]}>
                              {job.status}
                            </span>
                          ) : job.status.toLowerCase() === "rejected" ? (
                            <span className={style["failed"]}>
                              {job.status}
                            </span>
                          ) : (
                            <span className={style["new"]}>{job.status}</span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className={style["pagination--container"]}>
              {notFound || !smsAndVoiceJobs ? (
                ""
              ) : (
                <Pagination
                  numberOfPages={Math.ceil(smsAndVoiceJobs?.total / 15)}
                  currentPage={voiceCurrentPage}
                  nextPage={voiceMessageNextPage}
                />
              )}
            </div>
          </>
        )}

        {activeTab === "voice" && (
          <>
            <div ref={closeRef}>
              {isOpen && (
                <DropDown
                  handleSelect={(item) => handleVoiceMessageFilter(item)}
                />
              )}
              {isOpenDate && (
                <DateDropDown
                  startDate={startDate}
                  endDate={endDate}
                  handleStartDate={(date) => setStartDate(date)}
                  handleEndDate={(date) => setEndDate(date)}
                />
              )}
              {isOpenDuration && (
                <DurationDropDown
                  handleMaxDuration={(max) => setMaxDuration(max)}
                  handleMinDuration={(min) => setMinDuration(min)}
                />
              )}
            </div>
            <div className={style["table--top"]}>
              <div className={style["search-input"]}>
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleSmsAndVoiceSearch}
                />
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      style={{ fill: "#fff" }}
                      d="M19 19L13 13M15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <Button
                type="button"
                className="filter--button"
                onClick={handleOpenDropdown}
              >
                <span>
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.128568 2.26839L2.31563 0.125478C2.48647 -0.0418526 2.7636 -0.0417991 2.93434 0.125478L5.12132 2.26839C5.39667 2.53812 5.20059 3.00001 4.81195 3.00001H3.5V11.5714C3.5 11.8081 3.30414 12 3.0625 12H2.1875C1.94586 12 1.75 11.8081 1.75 11.5714V3.00001H0.437935C0.0485329 3.00001 -0.146209 2.53758 0.128568 2.26839ZM6.5625 1.7143H13.5625C13.8041 1.7143 14 1.52243 14 1.28573V0.428584C14 0.191879 13.8041 1.34454e-05 13.5625 1.34454e-05H6.5625C6.32086 1.34454e-05 6.125 0.191879 6.125 0.428584V1.28573C6.125 1.52243 6.32086 1.7143 6.5625 1.7143ZM6.125 4.71429V3.85715C6.125 3.62045 6.32086 3.42858 6.5625 3.42858H11.8125C12.0541 3.42858 12.25 3.62045 12.25 3.85715V4.71429C12.25 4.951 12.0541 5.14287 11.8125 5.14287H6.5625C6.32086 5.14287 6.125 4.951 6.125 4.71429ZM6.125 11.5714V10.7143C6.125 10.4776 6.32086 10.2857 6.5625 10.2857H8.3125C8.55414 10.2857 8.75 10.4776 8.75 10.7143V11.5714C8.75 11.8081 8.55414 12 8.3125 12H6.5625C6.32086 12 6.125 11.8081 6.125 11.5714ZM6.125 8.14286V7.28572C6.125 7.04901 6.32086 6.85715 6.5625 6.85715H10.0625C10.3041 6.85715 10.5 7.04901 10.5 7.28572V8.14286C10.5 8.37957 10.3041 8.57143 10.0625 8.57143H6.5625C6.32086 8.57143 6.125 8.37957 6.125 8.14286Z"
                      fill="#BDBDBD"
                    />
                  </svg>
                </span>
                Filter By {by?.by.split(" ")[0]}
                <span>{by?.icon}</span>
              </Button>
            </div>

            <div className={style["table--container"]}>
              <table
                id="test"
                style={{
                  border: "1px solid rgba(0, 0, 0, 0.4)",
                  borderRadius: "50px",
                }}
              >
                <thead>
                  <tr>
                    {voiceTh.map((item, index) => {
                      return <th key={index}>{item}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {notFound ? (
                    <tr className={style["empty--table"]}>
                      <span>
                        <svg
                          width="56"
                          height="46"
                          viewBox="0 0 56 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M45.5 45.5L56 17.5H10.5L0 45.5H45.5ZM7 14L0 45.5V0H15.75L22.75 7H45.5V14H7Z"
                            fill="#828282"
                          />
                        </svg>
                      </span>
                      <p>
                        Oops! you do not have any voice message <br />
                        at the moment.
                      </p>
                    </tr>
                  ) : loading ? (
                    <ScaleLoader />
                  ) : (
                    filteredSmsAndVoiceData?.map((job, index) => (
                      <tr
                        key={index}
                        className={style["table--body"]}
                        onClick={() => handleViewLog(job.id, job.name)}
                      >
                        <td>{index + 1}</td>
                        <td>{job.created_at}</td>
                        <td>
                          {job.message_text
                            ? job.message_text
                            : job.message_audio}
                        </td>
                        <td>{job.msisdn}</td>
                        <td>
                          {job.duration_in_seconds
                            ? job.duration_in_seconds
                            : 0}
                          s
                        </td>
                        <td>NGN {job.cost}</td>
                        <td>
                          {job?.jobstatus.toLowerCase() === "success" ? (
                            <span className={style["success"]}>
                              {job?.jobstatus}
                            </span>
                          ) : job?.jobstatus.toLowerCase() === "failed" ? (
                            <span className={style["failed"]}>
                              {job?.jobstatus}
                            </span>
                          ) : (
                            <span className={style["new"]}>
                              {job?.jobstatus}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className={style["pagination--container"]}>
              {notFound || !smsAndVoiceJobs ? (
                ""
              ) : (
                <Pagination
                  numberOfPages={Math.ceil(smsAndVoiceJobs?.total / 15)}
                  currentPage={voiceCurrentPage}
                  nextPage={voiceMessageNextPage}
                />
              )}
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

export default Logs;
